import { TimeframeGroup, Message, Suggestion } from '../../components/Analyse/type';

// Mock data for the sidebar conversations
export const mockTimeframeGroups: TimeframeGroup[] = [
  {
    label: 'aujourd\'hui',
    conversations: [
      {
        id: '1',
        title: 'first report',
        timestamp: new Date()
      }
    ]
  },
  {
    label: 'hier',
    conversations: [
      {
        id: '2',
        title: 'analyse sur les  SPA',
        timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000)
      },
      {
        id: '3',
        title: 'Raport',
        timestamp: new Date(Date.now() - 25 * 60 * 60 * 1000)
      },
      {
        id: '4',
        title: 'Report5',
        timestamp: new Date(Date.now() - 26 * 60 * 60 * 1000)
      }
    ]
  },
  {
    label: '7 jours précédents',
    conversations: [
      {
        id: '5',
        title: 'Solutions',
        timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000)
      },
      {
        id: '6',
        title: 'Expert Rport',
        timestamp: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000)
      }
    ]
  },
  {
    label: '30 jours précédents',
    conversations: [
      {
        id: '7',
        title: 'Mise à jour Dell 7480',
        timestamp: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000)
      },
      {
        id: '8',
        title: 'Expert Assistance',
        timestamp: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000)
      }
    ]
  }
];

// Mock data for initial messages (empty for new chat)
export const mockMessages: Message[] = [];

// Mock data for chat suggestions
export const mockSuggestions: Suggestion[] = [
  {
    id: '1',
    text: 'Écrire un scénario pour un court-métrage'
  },
  {
    id: '2',
    text: 'Écrire un scénario pour une comédie romantique'
  },
  {
    id: '3',
    text: 'Écrire un script pour une pièce de théâtre comique'
  },
  {
    id: '4',
    text: 'Écrire un scénario qui se déroule dans le futur'
  }
];